<template>
  <div class="container">
    <!-- <van-nav-bar title="订单详情" left-arrow @click-left="onClickLeft" /> -->
    <div class="isShowLoading" v-if="isShowLoading">
      <van-loading color="#aaa" vertical type="spinner" />
      <van-overlay :show="isShowLoading" />
    </div>
    <!-- 用户自己地址 -->
    <div class="addressTop" @click="clickAddress" v-if="agentShow.isShow == false">
      <van-cell icon="location-o" v-if="defaultAddress" :title="address.name + '，' + address.tel"
        :label="address.address" clickable value-class="address-tel" class="address" size="large" is-link></van-cell>
      <van-cell v-else clickable is-link class="cAddress">请选择地址</van-cell>
    </div>
    <!-- 代买地址 -->
    <div class="addressTopHeader" v-else>
      <van-cell icon="location-o" :title="agentShow.address.nickName + '，' + agentShow.address.cellPhone" :label="agentShow.address.province +
        agentShow.address.city +
        agentShow.address.district +
        agentShow.address.details
        " clickable value-class="address-tel" class="address" size="large"></van-cell>
    </div>
    <!--展示活动条  [{"moduleType":"title","title":"双十一活动正在执行中，点击查看详情。","linkId":111111111111132}]-->
    <div v-for="text in Activity" :key="text.linkId">
      <div class="activeNoticeBar" v-if="text.moduleType == 'title'">
        <div class="flex-between">
          <!-- icon -->
          <div class="flex">
            <svg class="activeIcon" aria-hidden="true">
              <use xlink:href="#icon-liwutubiao"></use>
            </svg>
            <div class="ellipsisText activeTitle">{{ text.title }}</div>
          </div>

          <div>
            <button class="agnetButton activeButton" @click="onLook(text)">
              查看活动
            </button>
          </div>
        </div>
      </div>
    </div>

    <van-list class="cardList">
      <van-panel title="订单商品" style="padding-top: 2px">
        <van-card v-for="item in goodsList" :key="item.id" :num="item.quantity" :price="formatPrice(item.retailPrice)"
          :title="item.goodsName" :desc="item.specificationNames" :thumb="item.pictureUrl" class="card_shop">
          <template #price>
            <div style="font-size: 18px">
              ￥{{ formatPrice(item.retailPrice) }}
              <!-- <span class="linePrice">￥{{ item.costPrice }}</span> -->
              <!-- <span class="vipPrice" v-if="authPrice > 0">
                <span class="vip">会员价</span>
                <span style="color:#FFAC36;padding:0.5vw 1vw">{{authPrice}}</span>
              </span>-->
            </div>
          </template>
        </van-card>
        <van-panel :border="false" v-if="goodsGiftList.length !== 0">
          <template slot="header">
            <div class="flex-between orderBottomGift">
              <!-- 绑定用户可以有新人大礼包 -->
              <!-- win 根据返回类型判断是否展示新人大礼包价格 -->
              <div class="panelHeader red" v-if="
                (userInfo.userType !== 'common' ||
                  userInfo.statusName !== 'limited') &&
                goodsGiftList[0].goodsType == 2
              ">
                新人首单大礼包{{
                  goodsGiftList.length > 1 ? "（任选一个）" : ""
                }}
              </div>
              <div class="panelHeader red" v-else>赠品</div>
            </div>
          </template>
          <!-- v-if="(userInfo.statusName !== 'limited')&&goodsGiftList[0].goodsType==2" -->
          <div v-if="
            userInfo.statusName !== 'limited' &&
            goodsGiftList[0].goodsType == 2 &&
            goodsGiftList.length == 1
          ">
            <div v-for="item in goodsGiftList" :key="item.goodsId">
              <van-card :num="item.quantity" :title="item.goodsName" :desc="item.specificationNames"
                :thumb="item.pictureUrl" class="card_Newshop">
              </van-card>
            </div>
          </div>
          <div v-if="
            userInfo.statusName !== 'limited' &&
            goodsGiftList[0].goodsType == 2 &&
            goodsGiftList.length > 1
          ">
            <div v-for="item in goodsGiftList" :key="item.goodsId">
              <van-radio-group v-model="radioChecked" direction="horizontal" style="width: 100%">
                <van-card :num="item.quantity" :title="item.goodsName" :desc="item.specificationNames"
                  :thumb="item.pictureUrl" class="card_Newshop">
                </van-card>
                <van-radio class="card-goods__item" :name="item.goodsId" v-model="item.checked" checked-color="#E02E24"
                  @click="onStatusRadioChange(item.goodsId)">
                </van-radio>
              </van-radio-group>
            </div>
          </div>
          <div v-if="
            userInfo.statusName !== 'limited' &&
            goodsGiftList[0].goodsType == 1
          ">
            <van-card v-for="item in goodsGiftList" :key="item.id" :num="item.quantity" :title="item.goodsName"
              :desc="item.specificationNames" :thumb="item.pictureUrl" class="card_shop">
            </van-card>
          </div>
        </van-panel>
        <van-submit-bar :price="actualPrice" button-text="去付款" @submit="onSubmitDialog" :disabled="button.disabled"
          :loading="button.loading" />
      </van-panel>
      <van-panel style="padding-top: 2px" v-if="activityGiftList.length">
        <template slot="header">
          <div class="panelh">
            选择赠品（可选{{ maxGiftNum }}件，已选{{ checkedGiftNum }}件）
          </div>
        </template>
        <div v-for="(item, index) in activityGiftList" :key="item.id">
          <div class="between checkoutGift">
            <div class="flex">
              <div class="checkoutImg">
                <img :src="item.picture" alt="" />
              </div>
              <div class="textGiftCenter">
                <div class="title">
                  {{ item.goodsName }}
                </div>
                <div class="specification">
                  {{ item.goodsSku }}
                </div>
              </div>
            </div>
            <div>
              <div class="checkoutMax" v-if="item.giftNum">
                最多可选{{ item.giftNum }} 件
              </div>
              <div class="checkoutMax" v-else>库存不足</div>
              <van-stepper :min="item.minQuantity" :max="item.maxQuantity"
                @change="onQuantityChange(item.quantity, index)" v-model="item.quantity" :disabled="item.disabled" />
            </div>
          </div>
        </div>
      </van-panel>
    </van-list>
    <div class="orderList">
      <van-cell :border="false" title="运费" value="包邮"></van-cell>
      <!-- win 根据是否展示新人大礼包 来决定是否展示border-->
      <van-cell :border="!(goodsGiftList.length !== 0 && goodsGiftList[0].goodsType == 2)
        " title="商品合计" :value="'￥' + formatPrice(goodsPrice)" class="computedPrice"></van-cell>
      <div></div>
      <!-- win 根据返回类型判断是否展示新人大礼包价格 -->
      <van-cell v-if="
        userInfo.statusName !== 'limited' &&
        goodsGiftList.length > 1 &&
        goodsGiftList[0].goodsType == 2 &&
        radioChecked == 0
      " title="新人首单大礼包" :value="'￥0.00'" class="computedPrice"></van-cell>
      <van-cell v-if="
        userInfo.statusName !== 'limited' &&
        goodsGiftList.length > 1 &&
        goodsGiftList[0].goodsType == 2 &&
        radioChecked > 0
      " title="新人首单大礼包" :value="'￥' + formatPrice(newPrice)" class="computedPrice"></van-cell>
      <van-cell v-if="
        userInfo.statusName !== 'limited' &&
        goodsGiftList.length == 1 &&
        goodsGiftList[0].goodsType == 2
      " title="新人首单大礼包" :value="'￥' + formatPrice(goodsGiftList[0].retailPrice)" class="computedPrice"></van-cell>
      <van-cell border title="实付金额" :value="'￥' + formatPrice(actualPrice / 100)" value-class="checkout-sum"></van-cell>
    </div>
    <!-- <div style="padding: 10px 0">
      <div>
        <van-cell title="商品总价" value-class="checkout-sum"
          >￥{{ formatPrice(actualPrice / 100) }}</van-cell
        >
        <van-cell
          :border="false"
          title="运费"
          value="包邮"
        ></van-cell>
         <van-cell
          :border="false"
          is-link
          title="选择优惠券"
          :value="coupon.couponTitle + '(-￥' + coupon.couponPrice + ')'"
          @click="isCouponsClick()"
          v-if="coupon.hasCoupon"
        ></van-cell>
        <van-cell
          :border="false"
          is-link
          title="选择优惠券"
          :value="coupon.couponTitle"
          v-else
          @click="isCouponsClick()"
        ></van-cell> 
      </div>
    </div>-->
    <!--优惠码不足，请手动领取购买码弹窗  -->
    <div class="claimCodeCard">
      <van-overlay :show="IsClaimCode">
        <div class="claimCode">
          <div class="claimCodeBox">
            <div class="claimCodeContent">赠送您</div>
            <div class="flexCenter" style="height: 17.1vw; font-size: 4.8vw">
              <div style="font-size: 11.73vw">
                {{ codeInfo !== null ? codeInfo.availableNum : 0 }}
              </div>
              <div>个优惠码</div>
            </div>
            <div class="claimCodeTips">请在{{ year }}年1月1日之前使用</div>
            <div @click="onHandleClaimCode">
              <button class="ClaimCodeButton">立即领取</button>
            </div>
          </div>
          <van-icon name="close" class="claimCodeClose" @click="IsClaimCode = false" />
        </div>
      </van-overlay>
    </div>
    <!-- 客服电话弹窗 -->
    <van-dialog v-model="IsPickUpShow" :showConfirmButton="false" @confirm="onConfirm">
      <!-- <div class="phoneContent">
        <button style="padding-bottom: 8px">正常支付</button>
        <button style="padding-bottom: 8px">提货码支付</button>
        
      </div> -->
      <div class="PickUpContent">
         <div style="padding-bottom: 20px">请选择支付方式</div>
         <van-icon
          name="cross"
          color="#c1c1c1"
          class="applyContentIcon"
          @click="onCancel"
        />
        <div class="Fbutton"><van-button style="width: 100%;border-radius: 8px;" @click="onSubmit">正常支付</van-button></div>
        <div>
          <van-button type="danger" block @click="onConfirm" style="border-radius: 8px">提货码支付</van-button>
        <div class="DialogTip">提示：提货码支付没有赠品，提货码剩余：{{ PickUp.count }}</div>
        </div>
      </div>
    </van-dialog>
    <!-- <van-popup v-model="IsPickUpShow" round closeable class="PickUpPop"> <div class="PickUpContent">
        <van-button style="margin-bottom: 8px">正常支付</van-button>
        <van-button>提货码支付</van-button>
        
      </div></van-popup> -->
    <van-overlay :show="isLoading" style="z-index: 102">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Cell,
  Tag,
  List,
  Card,
  Panel,
  SubmitBar,
  Toast,
  NavBar,
  Loading,
  Dialog,
  Overlay,
  Popup,
  Icon,
  RadioGroup,
  Radio,
  Stepper,
} from "vant";
import service from "../../api/checkout/index";
// import serviceOrder from "../../api/order/index";
import serviceUser from "../../api/user/index";
import { mapGetters, mapActions } from "vuex";
import { wxPay } from "../../util/wxHelper";
import servicePay from "../../api/payment/wxpay/index";
import serviceCart from "../../api/cart/index";
// import listener from "../../eventLlistener/listener.js";
// import address from "../../api/user/address";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [List.name]: List,
    [Card.name]: Card,
    [Panel.name]: Panel,
    [SubmitBar.name]: SubmitBar,
    [Toast.name]: Toast,
    [NavBar.name]: NavBar,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Dialog.Component.name]: Dialog.Component,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Stepper.name]: Stepper,
    loading,
  },
  data() {
    return {
      radioChecked: 0,
      // lhy 新增
      postSubmit: {}, //分享去付款数据
      // ======
      year: "2022", //年份
      IsClaimCode: false, //是否显示购买码弹窗
      Activity: [], //活动
      orderClass: "", //订单类型：0普通订单，1代买订单
      agentAddressId: "", //代买地址Id
      isbuttonStatus: false,
      isCoupons: true,
      addressId: 0,
      defaultAddress: false,
      isDefaultAddress: "请设置默认地址",
      address: {},
      goodsList: [],
      goodsGiftList: [],
      activityGiftList: [],
      maxGiftNum: 0,
      authPrice: 0,
      type: 0,
      getParams: {},
      button: {
        disabled: true,
        loading: false,
      },
      orderNo: "",
      goodsListId: 0,
      valList: "",
      getParamsAddress: {},
      isShowLoading: false,
      submitData: {},
      totalPrice: 0.0,
      coupon: { hasCoupon: false },
      isLoading: true, //loading状态
      PickUp: {},
      IsPickUpShow: false
    };
  },
  computed: {
    ...mapGetters(["userInfo", "cartInfo", "agentShow", "codeInfo"]),
    cartQuantity() {
      return this.cartInfo == null ? 0 : this.cartInfo;
    },
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
    cardType() {
      return this.chosenContactId !== null ? "edit" : "add";
    },
    currentContact() {
      const id = this.chosenContactId;
      return id !== null ? this.list.filter((item) => item.id === id)[0] : {};
    },
    // 已选中的赠品数量
    checkedGiftNum: {
      get() {
        let total = 0;
        this.activityGiftList.map((v) => {
          total += v.quantity;
        });
        return total;
      },
    },
    // win 新人大礼包实付金额
    actualPrice: {
      get() {
        let price = 0;
        let c = 0;
        let g = 0;
        this.goodsList.map((s) => {
          c += s.retailPrice * s.quantity;
        });
        // 新人大礼包价格为1元
        if (this.radioChecked > 0 && this.goodsGiftList.length > 1) {
          this.goodsGiftList.map((v) => {
            if (v.goodsType == 2 && v.goodsId == this.radioChecked) {
              g += v.retailPrice * v.quantity;
            }
          });
        }
        if (this.goodsGiftList.length == 1) {
          this.goodsGiftList.map((v) => {
            if (v.goodsType == 2) {
              g += v.retailPrice * v.quantity;
            }
          });
        }

        price = c + g;

        if (this.coupon.hasCoupon) {
          price -= this.coupon.couponPrice;
        }
        return price * 100;
      },
      set() { },
    },
    // 新人大礼包价格
    newPrice: {
      get() {
        let n = 0;
        if (this.radioChecked > 0 && this.goodsGiftList.length > 1) {
          this.goodsGiftList.map((v) => {
            if (v.goodsType == 2 && v.goodsId == this.radioChecked) {
              n += v.retailPrice * v.quantity;
            }
          });
        }
        return n;
      },
      set() { },
    },
    goodsPrice: {
      get() {
        let price = 0;
        this.goodsList.map((s) => {
          price += s.retailPrice * s.quantity;
        });
        if (this.coupon.hasCoupon) {
          price -= this.coupon.couponPrice;
        }
        return price;
      },
      set() { },
    },
    ...mapGetters(["userInfo"]),
  },
  methods: {
    ...mapActions(["updateUserCartQuantity", "updatePcode"]),
    formatPrice(price) {
      if (price > 0) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    clickAddress() {
      this.$router.push({
        name: "addresslist",
      });
    },
    // 查看跳到活动页面
    onLook(item) {
      this.$router.push({ name: "miniPage", query: { code: item.linkId } });
    },
    // onClickLeft() {
    //   localStorage.removeItem("getParams");
    //   this.$router.go(-1);
    // },
    isCouponsClick() {
      this.$router.push({
        name: "checkoutCoupons",
        query: {
          goodsCode: this.getParams.goodsCode,
          quantity: this.getParams.quantity,
          skuCode: this.getParams.skuCode,
          couponCode: this.coupon.couponCode,
          type: this.getParams.type,
        },
      });
    },
    pay() {
      console.log(this.orderNo, this.userInfo.openId, "参数");
      servicePay
        .unifiedOrder(this.orderNo, this.userInfo.openId)
        .then((res) => {
          wxPay(res.data)
            .then(() => {
              localStorage.removeItem("backHis");
              localStorage.removeItem("getParams");
              this.$router.replace({
                name: "payResult",
                query: { id: this.orderNo, status: true },
              });
            })
            .catch((err) => {
              this.$router.replace({
                name: "payResult",
                query: { id: this.orderNo, status: false },
              });
            });
        })
        .catch((err) => {
          this.$router.replace({
            name: "payResult",
            query: { id: this.orderNo, status: false },
          });
        });
    },
    onSubmitDialog() {
      // 默认普通订单
      this.submitData.orderClass = 0;
      if (this.AgentIsShow == false) {
        if (this.address.id == undefined) {
          Toast("请输入收货地址");
          return false;
        }
        this.getIsPickUp()
        console.log(this.PickUp.count>0,506)
        

      } else {
        this.submitData.orderClass = 1;
        this.submitData.agentAddressId = this.agentShow.address.id;
        this.onSubmit();
      }
    },
    // 关闭领取
    onHandleClaimCode() {
      this.isLoading = true;
      serviceUser
        .ManualClaim()
        .then((res) => {
          if (res.statusCode == 200) {
            this.IsClaimCode = false;
            Toast("领取成功");
            serviceUser
              .GetPCodeByPage()
              .then((response) => {
                if (response.statusCode == 200) {
                  setTimeout(() => {
                    this.isLoading = false;
                  }, 800);
                  let codeNum = {
                    available: response.data.available,
                    usable: response.data.usable,
                  };
                  this.updatePcode(codeNum);
                } else {
                  Toast(response.errors);
                  this.isLoading = false;
                }
              })
              .catch((err) => {
                this.isLoading = false;
                Toast(err);
              });
          } else {
            this.isLoading = false;
            Toast(res.errors);
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    // 新人大礼包多选1
    onStatusRadioChange(val) {
      this.submitData.giftPackageRequests = {
        goodsid: val,
      };
      console.log("选中", val, this.submitData);
    },
    // 是否有桃花恋提货码
    getIsPickUp() {
      console.log('getIsPickUp')
      this.isShowLoading = true;
      this.isLoading = true;
      service.CheckUserIsPickUp()
        .then((res) => {
          this.isShowLoading = false;
          if (res.statusCode == 200) {
            this.PickUp = res.data
            this.isLoading = false;
            if (this.PickUp.isPickCode&&this.PickUp.count>0) {
          console.log('111')
          // 满赠活动
          if (this.maxGiftNum > 0) {
            if (this.checkedGiftNum < this.maxGiftNum) {
              Toast(`赠品还可再选${this.maxGiftNum - this.checkedGiftNum}件`);
              this.isLoading = false;
              this.isShowLoading = false;
              return;
            }
            if (this.checkedGiftNum > this.maxGiftNum) {
              Toast(`赠品可选${this.maxGiftNum}件`);
              this.isLoading = false;
              this.isShowLoading = false;
              return;
            }
            
          }
          this.IsPickUpShow = true
          // this.CheckCodeSubmit()
        } else {
          // 正常支付
          this.onSubmit();
        }
          }
        })
    },
    // 确定
    onConfirm() {
      this.IsPickUpShow = false;
      this.CheckCodeSubmit()
    },
    // 取消
    onCancel() {
      this.IsPickUpShow = false;
    },
    // // 桃花恋521扣码支付
    CheckCodeSubmit() {
      localStorage.removeItem("getParamsAddress");
      this.isShowLoading = true;
      this.isLoading = true;
      console.log(this.submitData, 588)
   
      this.submitData.orderType = 2;
      //此处需要判断 是不是代买状态 如果是代代买状态 orderClass是1
      this.submitData.orderClass = 0;
      this.activityGiftList.map((i) => {
              i.giftNum = i.quantity;
            });
            this.submitData.giftGoods = this.activityGiftList;
      service.CheckOutByCode(this.submitData)
        .then((res) => {
          this.isShowLoading = false;
          if (res.statusCode == 200) {
            this.orderNo = res.data.orderId;
            localStorage.removeItem("backHis");
            localStorage.removeItem("getParams");
            this.$router.replace({
              name: "payResult",
              query: { id: this.orderNo, status: true },
            });
            setTimeout(() => {
              this.isLoading = false;
            }, 2000);
          }
        }).catch((err) => {
          this.isShowLoading = false;
          this.isLoading = false;
        //  this.$router.replace({
          //   name: "payResult",
          //   query: { id: this.orderNo, status: false },
          // });
        });
    },

    // 去付款
    onSubmit() {
      this.IsPickUpShow = false
      // let _arr = [];
      // let purchaseList = {};

      // this.goodsList.map((item) => {
      //   _arr.push(
      //     Object.assign({}, item, { couponNo: this.getParams.couponNo })
      //   );
      // });
      // purchaseList.goodsSkuList = _arr;
      // purchaseList.addressId = this.address.id;

      localStorage.removeItem("getParamsAddress");
      this.isShowLoading = true;
      this.isLoading = true;
   
      // 库存   购买库存和优惠码没有关系
      if (this.goodsList[0].goodsType == 2) {
        this.submitData.orderType = 4;
        serviceUser
          .post(this.submitData)
          .then((res) => {
            // this.isLoading = false;
            if (res.statusCode == 200) {
              this.orderNo = res.data.orderId;
              this.pay();
            } else {
              Toast(res.errors);
              setTimeout(() => {
                this.isLoading = false;
              }, 2000);
            }
          })
          .catch((err) => {
            Toast(err);
            setTimeout(() => {
              this.isLoading = false;
            }, 2000);
            this.isShowLoading = false;
          });
      } else {
        if (this.$route.query.type == 0) {
          // 立即购买
          this.submitData.orderType = 1;
          service
            .purchase(this.submitData)
            .then((response) => {
              // this.isLoading = false;
              this.isShowLoading = false;
              if (response.statusCode == 200) {
                this.orderNo = response.data.orderId;
                this.pay();
                setTimeout(() => {
                  this.isLoading = false;
                }, 2000);
              } else {
                setTimeout(() => {
                  this.isLoading = false;
                }, 2000);
                if (response.errors == "优惠码不足，请手动领取优惠码") {
                  this.IsClaimCode = true;
                } else {
                  this.IsClaimCode = false;
                  Toast(response.errors);
                  Dialog.alert({
                    title: "提示",
                    message: "购买库存之后才能购买...",
                  }).then(() => {
                    this.$router.push("user");
                  });
                }
              }
            })
            .catch((err) => {
              // win 优惠码不足，请手动领取购买码 可以去领取 跳弹窗
              // 购买码已达到上限 不能购买 提示出来
              if (err == "优惠码不足，请手动领取优惠码") {
                this.IsClaimCode = true;
              } else {
                this.IsClaimCode = false;
                Toast(err);
              }
              this.isShowLoading = false;
              setTimeout(() => {
                this.isLoading = false;
              }, 2000);
            });
        } else if (this.$route.query.type == 3) {
          // lhy 新增else if  原来只有if...else...
          //先判断 是不是代码状态
          if (this.agentShow.isShow == false) {
            this.postSubmit = {
              addressId: null,
              checkOutRequests: {},
              orderType: null,
              orderClass: null,
            };
            this.postSubmit.addressId = this.submitData.addressId;
            this.postSubmit.checkOutRequests.goodsId =
              this.submitData.checkOutRequests.goodsId;
            this.postSubmit.checkOutRequests.skuId =
              this.submitData.checkOutRequests.skuId;
            this.postSubmit.checkOutRequests.quantity =
              this.submitData.checkOutRequests.quantity;
            this.postSubmit.orderType = 1;
            //此处需要判断 是不是代买状态 如果是代代买状态 orderClass是1
            this.postSubmit.orderClass = 0;
          } else {
               console.log(this.submitData,'this.submitData1')
            this.postSubmit = {
              agentAddressId: null,
              checkOutRequests: {},
              orderType: null,
              orderClass: null,
            };
            this.postSubmit.agentAddressId = this.agentShow.address.id;
            this.postSubmit.checkOutRequests.goodsId =
              this.submitData.checkOutRequests.goodsId;
            this.postSubmit.checkOutRequests.skuId =
              this.submitData.checkOutRequests.skuId;
            this.postSubmit.checkOutRequests.quantity =
              this.submitData.checkOutRequests.quantity;
            this.postSubmit.orderType = 1;
            //此处需要判断 是不是代买状态 如果是代代买状态 orderClass是1
            this.postSubmit.orderClass = 1;
          }

          service
            .shareBuyShop(this.postSubmit)
            .then((response) => {
              // this.isLoading = false;
              this.isShowLoading = false;
              if (response.statusCode == 200) {
                this.orderNo = response.data.orderId;
                this.pay();
              } else {
                Toast(response.errors);
                Dialog.alert({
                  title: "提示",
                  message: "购买库存之后才能购买...",
                }).then(() => {
                  this.$router.push("user");
                });
              }
            })
            .catch((err) => {
              this.isShowLoading = false;
              setTimeout(() => {
                this.isLoading = false;
              }, 2000);

              Toast(err);
            });
        } else {
          // 新人大礼包类型2 多个产品任选其一
          if (
            this.goodsGiftList.length > 1 &&
            this.goodsGiftList[0].goodsType == 2
          ) {
            if (this.radioChecked == 0) {
              Toast("请选择礼包商品");
              this.isLoading = false;
              this.isShowLoading = false;
              return;
            }
          }
          // 新人大礼包类型2 一个产品
          if (
            this.goodsGiftList.length == 1 &&
            this.goodsGiftList[0].goodsType == 2
          ) {
            this.submitData.giftPackageRequests = {
              goodsId: this.goodsGiftList[0].goodsId,
            };
          }
          // 满赠活动
          if (this.maxGiftNum > 0) {
            if (this.checkedGiftNum < this.maxGiftNum) {
              Toast(`赠品还可再选${this.maxGiftNum - this.checkedGiftNum}件`);
              this.isLoading = false;
              this.isShowLoading = false;
              return;
            }
            if (this.checkedGiftNum > this.maxGiftNum) {
              Toast(`赠品可选${this.maxGiftNum}件`);
              this.isLoading = false;
              this.isShowLoading = false;
              return;
            }
            this.activityGiftList.map((i) => {
              i.giftNum = i.quantity;
            });
            this.submitData.giftGoods = this.activityGiftList;
          }

          // 购物车
          this.submitData.orderType = 2;
          service
            .purchaseCart(this.submitData)
            .then((response) => {
              this.isShowLoading = false;
              if (response.statusCode == 200) {
                this.orderNo = response.data.orderId;
                this.updateUserCartQuantity(
                  this.cartQuantity - response.data.cartGoodsNum
                );
                this.pay();
                setTimeout(() => {
                  this.isLoading = false;
                }, 2000);
              } else {
                setTimeout(() => {
                  this.isLoading = false;
                }, 2000);
                if (response.errors == "优惠码不足，请手动领取优惠码") {
                  this.IsClaimCode = true;
                } else {
                  this.IsClaimCode = false;
                  Toast(response.errors);
                  this.$router.replace("cart");
                }
              }
            })
            .catch((err) => {
              console.log(err, "判断库存不足的地方");
              var stockT = err;
              stockT.substr(-9);
              console.log(
                stockT.substr(-9),
                stockT.substr(-9) == "库存不足无法下单。",
                801
              );
              // Toast(err);
              // win 优惠码不足，请手动领取购买码 可以去领取 跳弹窗
              // 购买码已达到上限 不能购买 提示出来
              setTimeout(() => {
                this.isLoading = false;
              }, 2000);
              this.isShowLoading = false;
              if (stockT.substr(-9) == "库存不足无法下单。") {
                Dialog.confirm({
                  message: stockT,
                })
                  .then(() => {
                    // 跳到购物车
                    this.$router.replace("cart");
                  })
                  .catch(() => {
                    // on cancel
                  });
                return;
              }
              if (err == "优惠码不足，请手动领取优惠码") {
                this.IsClaimCode = true;
              } else {
                this.IsClaimCode = false;
                Toast(err);
                this.$router.replace("cart");
              }

              // 提示不对
            });
        }
      }
    },
    onQuantityChange(value, index) {
      console.log();
      if (value == this.activityGiftList[index].minQuantity) {
        Toast("最少可选" + this.activityGiftList[index].minQuantity + "件");
        this.activityGiftList[index].quantity = value;
        return;
      } else if (value == this.activityGiftList[index].maxQuantity) {
        Toast("最多可选" + this.activityGiftList[index].maxQuantity + "件");
        this.activityGiftList[index].quantity = value;
        return;
      } else {
        this.activityGiftList[index].quantity = value;
        return;
      }
    },
    // 添加联系人
    onAdd() {
      // this.editingContact = { id: this.list.length };
      this.isEdit = false;
      this.showEdit = true;
    },

    // 编辑联系人
    onEdit(item) {
      this.isEdit = true;
      this.showEdit = true;
      this.editingContact = item;
    },

    // 选中联系人
    onSelect() {
      this.showList = false;
    },

    // 保存联系人
    onSave(info) {
      this.showEdit = false;
      this.showList = false;

      if (this.isEdit) {
        this.list = this.list.map((item) =>
          item.id === info.id ? info : item
        );
      } else {
        this.list.push(info);
      }
      this.chosenContactId = info.id;
    },

    // 删除联系人
    onDelete(info) {
      this.showEdit = false;
      this.list = this.list.filter((item) => item.id !== info.id);
      if (this.chosenContactId === info.id) {
        this.chosenContactId = null;
      }
    },
    getAddress() {
      service.getDefault().then((response) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        if (response.statusCode == 200 && response.data !== null) {
          this.defaultAddress = true;
          this.address = {
            name: response.data.name,
            tel: response.data.cellPhone,
            address:
              response.data.province +
              response.data.city +
              response.data.district +
              response.data.details,
            id: response.data.id,
          };

          this.addressId = response.data.id;
          this.submitData.addressId = response.data.id;
        }
      });
    },
    // 立即购买
    getList(obj) {
      this.isShowLoading = true;
      // this.type = 2;
      service
        .get(obj)
        .then((response) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.isShowLoading = false;
          let data = response.data;
          this.goodsList = data;
          this.button.disabled = false;
          data.map((i) => {
            this.submitData.checkOutRequests = {
              goodsId: i.goodsId,
              skuId: i.skuId,
              quantity: i.quantity,
              skuCode: i.skuCode,
              skuNo: i.skuNo,
            };
          });

          // service.getDefaultCoupon(obj.couponCode).then(res => {
          //   let coupon = res.data;

          // if (this.valList == "") {
          //   this.coupon = {
          //     hasCoupon: false,
          //     couponNo: "",
          //     couponCode: "",
          //     couponTitle: "",
          //     couponPrice: 0
          //   };
          //   this.submitData.couponCode = "";
          //   this.submitData.couponNo = "";
          // } else {
          //   if (this.valList.text == "不使用优惠券") {
          //     this.coupon = {
          //       hasCoupon: false,
          //       // list: 1,
          //       couponPrice: 0,
          //       couponTitle: this.valList.text
          //     };
          //     this.submitData.couponCode = "";
          //     this.submitData.couponNo = "";
          //   } else if (this.valList.text == "选择优惠券") {
          //     service
          //       .getCouponPrice(obj.couponCode, obj.goodsCode, obj.skuCode)
          //       .then((res) => {
          //         this.coupon = {
          //           hasCoupon: true,
          //           couponNo: this.valList.item.couponNo,
          //           couponCode: this.valList.item.couponCode,
          //           couponTitle: this.valList.item.couponTitle,
          //           couponPrice: data.actualPrice - res.data
          //         };
          //         this.submitData.couponCode = this.valList.item.couponCode;
          //         this.submitData.couponNo = this.valList.item.couponNo;
          //         // this.actualPrice = this.totalPrice - this.coupon.price;
          //         // this.getParams.userCouponId = this.valList.item.id;
          //       });
          //   }
          // }

          // });

          this.getParams.address = this.address;
        })
        .catch((error) => {
          if (error.status == 404) {
            this.showEmpty = true;
          }
        });
    },
    getCartList() {
      service.getBasketCheckout().then((response) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.isShowLoading = false;
        if (response.data.commonOrderResponses.length == 0) {
          Toast("商品已下架");
          this.$router.go(-1);
        }
        this.goodsList = response.data.commonOrderResponses;
        if (response.data.giftOrderResponses) {
          this.goodsGiftList = response.data.giftOrderResponses;
        }
        if (response.data.activityGiftResponse) {
          this.maxGiftNum = response.data.maxGiftNum; //最大可选择赠品数量
          response.data.activityGiftResponse.map((i) => {
            i.maxQuantity = i.giftNum;
            i.minQuantity = 0;
            i.quantity = 0;
            if (i.giftNum) {
              i.disabled = false;
            } else {
              i.disabled = true;
            }
          });
          this.activityGiftList = response.data.activityGiftResponse;
        }
        // this.totalPrice = data.totalPrice;
        this.button.disabled = false;

        this.getParams.address = this.address;
      });
    },
    // 活动通知栏
    getActivity() {
      service.GetActive().then((res) => {
        if (res.statusCode == 200 && res.data !== null) {
          this.Activity = JSON.parse(res.data.htmlJson);
        } else {
          this.Activity = [];
        }
      });
    },
    //lhy分享的时候获取订单商品
    getShareList(obj) {
      this.isShowLoading = true;
      service
        .getShareList(obj)
        .then((response) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.isShowLoading = false;
          let data = response.data;
          this.goodsList = data;
          this.button.disabled = false;
          data.map((i) => {
            this.submitData.checkOutRequests = {
              goodsId: i.goodsId,
              skuId: i.skuId,
              quantity: i.quantity,
              skuCode: i.skuCode,
              skuNo: i.skuNo,
            };
          });
          this.getParams.address = this.address;
        })
        .catch((error) => {
          if (error.status == 404) {
            this.showEmpty = true;
          }
        });
    },
  },

  mounted() {
    var date = new Date();
    this.year = date.getFullYear() + 1;
    let obj = this.$route.query;
    this.getParams = obj;
    this.submitData.giftPackageRequests = {
      goodsId: 0,
    };
    if (this.$route.query.type == 0) {
      // 立即购买
      this.getList(obj);
      this.submitData.goodsCode = obj.goodsCode;
      this.submitData.skuCode = obj.skuCode;
      this.submitData.quantity = obj.quantity;
    } else if (this.$route.query.type == 3) {
      // lhy 新增 原来只有 if...else...
      //获取订单商品接口
      let shareParams = {
        goodsId: obj.goodsId,
        skuId: obj.skuId,
        quantity: obj.quantity,
      };
      this.getShareList(shareParams);
    } else {
      // 购物车
      this.getCartList();
    }
    // GetActive
    this.getActivity();
    if (localStorage.getItem("backHis")) {
      this.valList = JSON.parse(localStorage.getItem("backHis"));
    }
    if (localStorage.getItem("getParamsAddress")) {
      this.getParamsAddress = JSON.parse(
        localStorage.getItem("getParamsAddress")
      );
    }
    // 代买状态
    // if (this.AgentIsShow == false) {
    // 获取缓存地址
    if (this.getParamsAddress.addressId) {
      this.defaultAddress = true;
      this.address = {
        id: this.getParamsAddress.address.id,
        name: this.getParamsAddress.address.name,
        tel: this.getParamsAddress.address.tel,
        address: this.getParamsAddress.address.address,
      };
      this.submitData.addressId = this.getParamsAddress.address.id;
    } else {
      // 获取默认地址
      this.getAddress();
    }

    // }
  },
  destroyed() {
    localStorage.removeItem("getParamsAddress");
    localStorage.removeItem("backHis");
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.container {
  height: calc(100% - 13vw);
  overflow: auto;
}

.van-radio--horizontal {
  margin-right: 16px;
}

.van-radio {
  @{deep} .van-radio__icon {
    width: 18px;
    height: 18px;
  }

  @{deep} .van-radio__icon .van-icon {
    width: 18px;
    height: 18px;
    line-height: 18px;
    margin-right: 14px;
  }
}
.DialogTip{
color: #ee0a25;
font-size: 12px;
 margin-top: 12px;
}
.PickUpPop {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.PickUpContent {
  padding: 20px 16px;
  text-align: center;
  position: relative;
  .applyContentIcon{
    position: absolute;
    right: 16px;
    top: 16px;
  }
  .Fbutton{
    margin: 0 0 10px;
  }
}

.orderBottomGift {
  border-bottom: 1px solid #f7f7f7;
  height: 45px;
}

.card_Newshop {
  flex: 1;

  .van-card__content {
    .van-card__bottom {
      .van-card__num {
        float: left;
      }
    }
  }
}

.panelh {
  padding: 16px 16px 0;
}

.checkoutGift {
  padding: 16px;
}

.checkoutImg {
  width: 80px;
  height: 80px;
  border-radius: 2px;
  margin-right: 12px;

  img {
    border-radius: 2px;
  }
}

.textGiftCenter {
  max-width: 140px;
  margin-right: 8px;

  .title {
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 8px;
  }

  .specification {
    font-size: 12px;
    line-height: 12px;
    color: rgba(102, 102, 102, 1);
  }
}

.checkoutMax {
  font-size: 12px;
  line-height: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 8px;
  text-align: end;
}

.goodsGift {
  background: #fff;
  margin: 0 4.26667vw;
  padding: 4vw 0;
  border-bottom: 1px solid #f7f7f7;

  .gitText {
    height: 14px;
    font-weight: 500;
    color: #1a1a1a;
    line-height: 14px;
  }
}

.claimCode {
  background-image: url(../../../assets/images/claimCodePop.png);
  background-repeat: no-repeat;
  background-size: 100vw 112.7vw;
  width: 100vw;
  height: 113vw;
  margin: auto;
  position: relative;
  top: 50%;
  margin-top: -61.5vw;
}

.ClaimCodeButton {
  width: 45vw;
  height: 11.46vw;
  background: linear-gradient(180deg, #ffeac1 0%, #fabc7a 100%);
  border-radius: 16.26vw;
  opacity: 1;
  border: 0;
  margin-top: 9vw;
}

.claimCodeBox {
  position: absolute;
  z-index: 16;
  top: 41.1vw;
  width: 100%;
  text-align: center;
  color: #c05e32;
  font-weight: bold;
}

.claimCodeContent {
  height: 5.33vw;
  font-size: 3.73vw;
  line-height: 5.1vw;
  width: auto;
}

.claimCodeTips {
  font-size: 2.7vw;
  color: #b5b5b5;
}

.orderList {
  margin-bottom: 20vw;
}

.cardList {
  .flex-between {
    margin: 0 4.26667vw;
    width: auto;
    font-size: 14px;
  }
}

.addressTopHeader {
  .van-cell--large .van-cell__label {
    width: 84vw;
    word-break: break-all;
  }
}

.fix-position {
  background: #f7f7f7;
}

.nullAddress {
  background: #fff;
  padding: 5vw 0;
  font-size: 4.1vw;
  color: #333;
  margin: 2vw 0;
}

/* 全局代买 */
.activeNoticeBar {
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
  background: RGBA(247, 228, 231, 1);
  color: #ee0a25;
}

.vip {
  background-color: #ffac36;
  padding: 0.5vw 1vw;
  color: #fff;
  text-align: center;
  margin: 0;
}

.vipPrice {
  border: 1px solid #ffac36;
  border-radius: 4px;
  padding: 0.5vw 0;
  font-size: 2.6vw;
}

// .address::before {
//   position: absolute;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   height: 2px;

//   background: repeating-linear-gradient(
//     -45deg,
//     #ff6c6c 0,
//     #ff6c6c 20%,
//     transparent 0,
//     transparent 25%,
//     #1989fa 0,
//     #1989fa 45%,
//     transparent 0,
//     transparent 50%
//   );
//   background-size: 80px;
//   content: "";
// }
// .checkout-sum {
//   color: #ee0a24;
// }</style>
